import get from 'lodash/get';
import { takeLatest, put, select } from 'redux-saga/effects';
import { consts as communityPosts } from './communityPosts';
import { consts as currentCommunity } from './currentCommunity';
import { consts as postsList } from './postsList';

function* currentCommunityWorker(action) {
  // current community id
  const state = yield select();
  const currentCommunityId = get(state, 'communities.currentCommunity');
  // next community id
  const communityId = parseInt(get(action, 'payload.communityId'), 10);

  if (communityId !== currentCommunityId) {
    yield put({
      type: postsList.RESTORE,
    });
  }

  yield put({
    type: currentCommunity.SET,
    payload: communityId,
  });
}

export function* currentCommunitySaga() {
  yield takeLatest(communityPosts.SEND, currentCommunityWorker);
}



// WEBPACK FOOTER //
// ./src/redux/communities/currentCommunitySaga.js